import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ModalService } from '@ibe/services/ui';
import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { Observable, combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import * as fromStore from '@ibe/store/index';
import * as _ from 'lodash';

import { BookedTrip } from '@ibe/models';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { ActivatedRoute } from '@angular/router';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';


@Component({
	selector: 'app-extras-sidebar-miles-info',
	templateUrl: './extras-sidebar-miles-info.indra.component.html',
	styleUrls: ['./extras-sidebar-miles-info.component.scss']
})
export class INDRAExtrasSidebarMilesInfoComponent {

	@Input() milesNeeded;
	@Input() addedAncillary: any;
	@Input() payExtrasWithMiles: boolean = false;
	@Input() notEnoughMilesFlag: boolean = true;
	@Input() hasAddedExtrasFlag: boolean;
	@Output() isChecked = new EventEmitter<boolean>();

	// Corp (note: from post-sprint 8 client code merge)
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	// isCorporate: boolean;
	// promoname: string;
	// promotype: string;

	// User info
	user$: Observable<any> = this.store.select(fromStore.getUserInfo);
	user: any;
	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	milesSpent$: Observable<number> = this.store.select(fromStore.getTotalMilesToSpend);
	private hasChanges$: Observable<any> = combineLatest([this.user$, this.milesSpent$]);

	hasExtras: boolean = false;
	hasLoggin: boolean = false;
	userMiles = 0;
	// milesNeeded = 0;
	// promoCoin: string;
	// payExtrasWithMiles: boolean = false;
	isAlive: boolean = true;
	ancillary$: Observable<any> = this.store.select(fromStore.getAncillaryToPayWithMiles);
	ancillary;
	milesSpent = 0;
	public flightID: number;
	public payExtrasWithMilesStatus: boolean = false;
	public ancType: string;
	public prevPayWithMilesFlightList: any = [];


	constructor(
		private store: Store<fromStore.State>,
		private modalService: ModalService,
		protected storageService: INDRAStorageService,
		private route: ActivatedRoute,
		protected ancillariesSelectionSrv: INDRAAncillariesSelectionService
	) {
		this.ancType = this.storageService.get('ancType');

		this.route.queryParams.subscribe(params => {
			this.flightID = params['flight'];
		});

		this.hasChanges$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(([value, milesSpent]) => {
				if (value) {
					this.milesSpent = milesSpent;
					this.hasLoggin = true;
					this.userMiles = parseInt(value.currentPoints, 10) - this.milesSpent;
				} else
					this.hasLoggin = false;
			});

		/* note: from post-sprint 8 client code merge
		this.isCorporate$.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isCorporate = value;
				if (value === true) {
					this.promotype = 'balance';
					this.promoCoin = '€';
				} else {
					this.promotype = 'miles';
					this.promoCoin = 'M';
				}
			});
		*/

		/* this.ancillary$.pipe(takeWhile(() => this.isAlive))
			.subscribe((value) => {
				if (value) {
					this.ancillary = this.payAncillariesWithMilesService.getMilesToPayAncillary(value, this.promotype);
				}
				if (this.ancillary) {
					this.milesNeeded = this.ancillary.total;
					this.hasExtras = this.ancillary.count !== 0;
				} else {
					this.milesNeeded = 0;
					this.hasExtras = true;
				}
			}); */

		this.prevPayWithMilesFlightList = _.cloneDeep(this.ancillariesSelectionSrv.payWithMilesFlightList);
		this.storageService.set('prevPayWithMilesFlightList', this.prevPayWithMilesFlightList);
	}

	ngOnInit() {
		if (this.payExtrasWithMiles && this.hasAddedExtrasFlag) {
			const isChecked = this.payExtrasWithMiles && this.hasAddedExtrasFlag
			this.ancillariesSelectionSrv.INDRA_getPayWithMilesByFlightId(this.flightID, isChecked, this.ancType);
		}

		this.payExtrasWithMilesStatus = this.ancillariesSelectionSrv.INDRA_getFlightPayWithMilesStatus(this.flightID, this.ancType) || (this.payExtrasWithMiles && this.hasAddedExtrasFlag);
		this.isChecked.emit(this.payExtrasWithMilesStatus);
		sessionStorage.setItem("is"+this.ancType+"withMiles", JSON.stringify(this.payExtrasWithMilesStatus));
	}

	INDRA_handleLogin() {
		this.modalService.assignComponent(INDRALoginModalComponent);
		this.modalService.open();
	}

	INDRA_useMilesChange(event) {
		// this.payExtrasWithMiles = event.target.checked;
		this.ancillariesSelectionSrv.INDRA_getPayWithMilesByFlightId(this.flightID, event.target.checked, this.ancType);
		this.payExtrasWithMilesStatus = this.ancillariesSelectionSrv.INDRA_getFlightPayWithMilesStatus(this.flightID, this.ancType) || (this.payExtrasWithMiles && this.hasAddedExtrasFlag);
		sessionStorage.setItem("is"+this.ancType+"withMiles", JSON.stringify(event.target.checked));
		this.isChecked.emit(this.payExtrasWithMilesStatus);
	}

	INDRA_hasAddedExtras() {
		return this.hasAddedExtrasFlag;
		// if (this.addedAncillary) {
		// 	if (this.addedAncillary.length != 0) {
		// 		return true;
		// 	}
		// }
		// return false;
	}

	/* note: from post-sprint 8 client code merge
	TAP_getPromoNomenclature(): string {
		return this.promotype;
	}
	*/
}

